import { v4 as uuid } from "uuid";
import POPUP_MESSAGE_TYPE from "../popupMessageType";
import actionTypes from "./actionTypes";
const actions = {
    addMessage: (type, message, autoHide, messageLink) => ({
        type: actionTypes.ADD_MESSAGE,
        payload: {
            id: uuid(),
            type: type || POPUP_MESSAGE_TYPE.INFO,
            message,
            autoHide: autoHide === undefined ? true : autoHide,
            messageLink
        }
    }),
    cleanMessages: (ids) => ({
        type: actionTypes.CLEAN_MESSAGES,
        payload: { ids }
    })
};
export const error = (message, autoHide, messageLink) => actions.addMessage(POPUP_MESSAGE_TYPE.ERROR, message, autoHide, messageLink);
export const info = (message, autoHide, messageLink) => actions.addMessage(POPUP_MESSAGE_TYPE.INFO, message, autoHide, messageLink);
export const success = (message, autoHide, messageLink) => actions.addMessage(POPUP_MESSAGE_TYPE.SUCCESS, message, autoHide, messageLink);
export default actions;
